<template>
  <div>
    <div v-for="(value, key) of riskPolicy" :key="key">
      <div v-if="!nonEditableFields.includes(key)" class="columns">
        <div class="column">{{ key }}</div>
        <b-switch v-if="typeof value === 'boolean'" class="column" :disabled="isLoading" :value="value" @input="updateRiskPolicy(riskPolicy._id, { [key]: $event })" />
        <b-numberinput
          v-else-if="typeof value === 'number'"
          :value="value"
          size="is-small"
          controls-rounded
          rounded
          :disabled="isLoading"
          class="number-input column"
          @keyup.native.enter="updateRiskPolicy(riskPolicy._id, { [key]: $event.target.valueAsNumber })" />
        <div v-else class="column">{{ value }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { updateRiskPolicy } from '@/application/services/api-clients/risk-policies';

export default {
  props: ['riskPolicy', 'country'],
  data() {
    return {
      nonEditableFields: ['_id', 'subSegmentDescription', 'subSegment', 'segment', 'updatedAt'],
      isLoading: false
    };
  },
  methods: {
    async updateRiskPolicy(riskPolicyId, updateObj) {
      this.isLoading = true;
      const updatedRiskPolicy = await updateRiskPolicy(this.country, riskPolicyId, updateObj);
      this.$emit('updated', updatedRiskPolicy);
      this.isLoading = false;
    }
  }
};
</script>
<style>
.column {
  padding: 1% 3%;
}
</style>
